module.exports = __webpack_public_path__ + "img/protectioncivile.8b4df6c3.png";